/**
 * @file 解析浏览器信息
 */
/**
 * Copy from Bowser
 * https://github.com/lancedikson/bowser/blob/master/src/parser-browsers.js
 *
 * The idea of descriptors is simple. You should know about them two simple things:
 * 1. Every descriptor has a method or property called `test` and a `describe` method.
 * 2. Order of descriptors is important.
 *
 * More details:
 * 1. Method or property `test` serves as a way to detect whether the UA string
 * matches some certain browser or not. The `describe` method helps to make a result
 * object with params that show some browser-specific things: name, version, etc.
 * 2. Order of descriptors is important because a Parser goes through them one by one
 * in course. For example, if you insert Chrome's descriptor as the first one,
 * more then a half of browsers will be described as Chrome, because they will pass
 * the Chrome descriptor's test.
 *
 * Descriptor's `test` could be a property with a RegExp
 * Or `test` could be a method. In that case it gets a Parser instance and should
 * return true/false to get the Parser know if this browser descriptor matches the UA or not.
 */
import { getFirstMatch, getSecondMatch, isAndroid } from './utils';
// 默认的版本号获取方式
const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const weWorkDescriber = (ua) => {
    const browser = {
        name: 'WeWork',
    };
    const version = getFirstMatch(/wxwork\/([\w.]+)/i, ua);
    if (version) {
        browser.version = version;
    }
    return browser;
};
export const browserParser = [
    {
        test: /msie|trident/i,
        describe(ua) {
            const browser = {
                name: 'InternetExplorer',
            };
            const version = getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /edg([ea]?|ios)/i,
        describe(ua) {
            const browser = {
                name: 'MicrosoftEdge',
            };
            const version = getSecondMatch(/edg([ea]?|ios)\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /firefox|iceweasel|fxios/i,
        describe(ua) {
            const browser = {
                name: 'Firefox',
            };
            const version = getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /micromessenger/i,
        describe(ua) {
            // 企业微信 ua 也会携带 micromessenger
            if (/wxwork/i.test(ua)) {
                return weWorkDescriber(ua);
            }
            const browser = {
                name: 'WeChat',
            };
            const version = getFirstMatch(/micromessenger\/([\w.]+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /c3app/i,
        describe(ua) {
            const browser = {
                name: 'C3AppWebView',
            };
            const version = getFirstMatch(/c3app\/([\w.]+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /dingtalk/i,
        describe(ua) {
            const browser = {
                name: 'DingTalk',
            };
            const version = getFirstMatch(/dingtalk\/([\w.]+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /wxwork/i,
        describe: weWorkDescriber,
    },
    {
        test: /ucbrowser/i,
        describe(ua) {
            const browser = {
                name: 'UC',
            };
            const version = getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) ||
                getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /chrome|crios|crmo/i,
        describe(ua) {
            const browser = {
                name: 'Chrome',
            };
            const version = getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: isAndroid,
        describe(ua) {
            const browser = {
                name: 'Android',
            };
            const version = getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
    {
        test: /safari|applewebkit/i,
        describe(ua) {
            const browser = {
                name: 'Safari',
            };
            const version = getFirstMatch(commonVersionIdentifier, ua);
            if (version) {
                browser.version = version;
            }
            return browser;
        },
    },
];
//# sourceMappingURL=data:application/json;base64,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